import React, { FC, ReactElement, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { FormControl } from '../../ui/FormControl';
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as FillClose } from '../../../assets/images/fillClose.svg';
import classes from './RestorePassword.module.scss';
import { ReactComponent as Point } from '../../../assets/images/point.svg';
import { useSendEmail } from '../../../hooks/entityHooks';

type FormikValues = {
  email: string;
};

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const RestorePassword = ({ open, setOpen }: Props): ReactElement => {
  const { sendEmail } = useSendEmail();

  const handleClose = () => {
    setOpen(false);
  };
  const useStyles = makeStyles({
    root: {
      background: '#FF7221 !important',
      borderRadius: '0 !important',
      color: 'white',
      width: 190,
      fontSize: 16,
      fontFamily: 'Inter, sans-serif',
      fontWeight: 550,
      textTransform: 'none',
      '&:hover, &:focus': {
        background: '#C8524D',
      },
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 5px',
      marginLeft: 10,
    },
    cancel: {
      borderRadius: '0 !important',
      color: '#FF7221 !important',
      fontWeight: 550,
      width: 190,
      fontSize: 16,
      border: ['1px', 'solid', '#FF7221', '!important'].join(' '),
      borderColor: '#FF7221',
      fontFamily: 'HelveticaNeueCyr',
      // '&:hover, &:focus': {
      //   background: '#EB564F',
      // },
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 5px',
      margitRight: 10,
      textTransform: 'none',
    },
  });

  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
  } = useFormik<FormikValues>({
    initialValues: {
      email: '',
    },
    onSubmit: () => {
      sendEmail(values.email);
      handleClose();
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required('Обязательно для заполнения'),
    }),
    validateOnMount: true,
  });
  const [focus, setFocus] = useState(false);

  const style = useStyles();
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          <div className={classes.form__dialogTitle}>
            <div className={classes.form__dialogTitle__title}>
              Восстановить пароль
            </div>
            <div
              className={classes.close}
              onMouseOver={(e) => setFocus(true)}
              onMouseOut={(e) => setFocus(false)}
              onClick={(e) => setOpen(false)}
            >
              {focus ? <FillClose /> : <Close />}
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div>
            <div className={classes.title}>
              <p>E-mail</p>
              <Point className={classes.title__point} />
            </div>

            <div>
              <FormControl
                placeholder="E-mail"
                type="text"
                name="email"
                value={values.email}
                onChange={(e) => setFieldValue('email', e.target.value)}
                error={Boolean(errors?.email && touched?.email)}
                errorMessage={errors?.email}
                onBlur={handleBlur}
                // onFocus={setFieldTouched('email', false)}
              />
            </div>
          </div>
        </DialogContent>
        <div className={classes.form__row__button}>
          <Button
            className={style.cancel}
            onClick={handleClose}
            color="primary"
          >
            Отмена
          </Button>
          <Button className={style.root} type="submit" color="primary">
            Отправить письмо
          </Button>
        </div>
      </form>
    </Dialog>
  );
};
